<template>
  <div class="compressed-content">
    <h3>Are you on medication to lower your LDL levels?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.isOnMedicationToLowerLDL">
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.isOnMedicationToLowerLDL" name="medication"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.isOnMedicationToLowerLDL" name="medication"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    validations: {
      isOnMedicationToLowerLDL: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      isOnMedicationToLowerLDL() { return this.survey.bloodBiochemistry.cholesterol.isOnMedicationToLowerLDL; }
    }
  };
</script>